<template>
    <modal name="update_page" height="auto" width="70%" scrollable adaptive @before-open="beforeOpen">
        <app-card :title="$t('Update page')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="update(validate)">
                    <app-multi-lang-quill
                        :title="$t('Content')"
                        id="content"
                        v-model="form.page"
                        :langs="locales && Object.keys(locales)" />
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Update') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import {mapGetters} from 'vuex';
import PublicPageService from '@services/publicPage.service';

export default {
    data() {
        return {
            form: {},
            loading: false,
            page_id: null
        };
    },
    computed: {
        ...mapGetters(['locales'])
    },
    methods: {
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    PublicPageService.update(this.page_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.hide();
                        this.$emit('setPage', res);
                    });
                }
            });
        },
        beforeOpen(event) {
            const page = event.params.page;
            if (page) {
                this.form.page = Object.assign({}, page.value);
                this.page_id = page.id;
            }
        },
        hide() {
            this.$modal.hide('update_page');
        }
    }
};
</script>
